export default __webpack_public_path__ + "static/media/RenoMono.8b239c68.otf";